var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col margin-bottom-50 links"},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_c('a',{attrs:{"href":_vm.block.link_url_1}},[_vm._v(_vm._s(_vm.block.link_txt_1))])]),_c('li',[_c('a',{attrs:{"href":_vm.block.link_url_2}},[_vm._v(_vm._s(_vm.block.link_txt_2))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }